export default "__VITE_ASSET__BM6zto4O__"